var map = {
	"./lagos/op1.png": "3b88",
	"./lagos/op2.png": "1407",
	"./lagos/op3.png": "3338",
	"./lagos/op4.png": "e423",
	"./roseiral/1.png": "c9f4",
	"./roseiral/2.png": "e50d",
	"./roseiral/3.png": "66ae",
	"./roseiral/4.png": "ce23",
	"./vale/1.png": "72ec",
	"./vale/2.png": "d546",
	"./vale/3.png": "5cb8",
	"./vale/4.png": "7906"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1336";